import { useCallback, useEffect, useState } from "react";
import { UNSAFE_NavigationContext, useNavigate } from "react-router-dom";
import { useContext } from "react";
import Modal from "@/components/Global/Modal";
import PrimaryBtn, { SecondaryBtn } from "@/components/Global/Button";
import useViewStyle from "../Stores/viewStyleStore";
import useProjectStore from "../Stores/projectStore";
//import { Modal, Button } from "@mui/material"; // Assuming you're using MUI

export const usePrompt = (message: string, dirty: boolean, formik?: any) => {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  const [showModal, setShowModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [customDirty, setCustomDirty] = useState(false);
  const setSelectedMenu = useViewStyle((state: any) => state.setSelectedMenu);
  const previousMenu = useViewStyle((state: any) => state.previousMenu);
  const setSelectedMenuSideBar = useProjectStore(
    (state: any) => state.setSelectedMenu
  );
  const [navigationPath, setNavigationPath] = useState(null);
  const previousMenuSideBar = useProjectStore(
    (state: any) => state.previousMenu
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (formik) {
      const hasChanged =
        JSON.stringify(formik.values) !== JSON.stringify(formik.initialValues);
      setCustomDirty(hasChanged);
    } else {
      setCustomDirty(dirty);
    }
  }, [dirty, formik]);

  useEffect(() => {
    if (!customDirty) return;

    const push = navigator.push;
    navigator.push = (to: string, options?: any) => {
      // Only show modal if Formik form is dirty
      if (customDirty) {
        setShowModal(true);
        setPendingNavigation(() => () => push(to, options));
        setNavigationPath(to);
      } else {
        push(to, options);
        setNavigationPath(null);
      }
    };

    // Handle browser back/forward/close
    // const handleWindowClose = (e: BeforeUnloadEvent) => {
    //   if (customDirty) {
    //     e.preventDefault();
    //     e.returnValue = message;
    //     return message;
    //   }
    // };

    // window.addEventListener("beforeunload", handleWindowClose);

    return () => {
      //   window.removeEventListener("beforeunload", handleWindowClose);
      navigator.push = push; // Restore original push function
    };
  }, [message, customDirty, navigator]);

  const handleMutationSuccess = useCallback(
    (path?: any) => {
      setCustomDirty(false);

      path &&
        setTimeout(() => {
          navigate(path, { replace: true });
        }, 1);
    },
    [navigate]
  );

  const handleCloseModal = () => {
    setShowModal(false);
    if (navigationPath?.pathname?.includes("/project/")) {
      if (previousMenuSideBar) {
        setSelectedMenuSideBar(previousMenuSideBar, null);
      }
    } else {
      if (previousMenu) {
        setSelectedMenu(previousMenu, null);
      }
    }

    setNavigationPath(null);
  };

  const PromptModal = () =>
    showModal ? (
      <Modal
        handleClose={() => handleCloseModal()}
        title="Unsaved Changes"
        leftAlign
        central
      >
        <h2>{message}</h2>
        <div className="flex justify-between gap-4 w-full mt-4">
          <SecondaryBtn
            onClick={() => {
              handleCloseModal();
            }}
            text="Stay"
            fullWidth={true}
          />
          <PrimaryBtn
            onClick={() => {
              if (pendingNavigation) {
                pendingNavigation();
              }
              setShowModal(false);
              setNavigationPath(null);
            }}
            fullWidth={true}
            text="Leave"
          />
        </div>
      </Modal>
    ) : null;

  return { PromptModal, customDirty, setCustomDirty, handleMutationSuccess };
};
